module.exports = __webpack_public_path__ + "img/template3.1e7c16d8.jpg";